/**
 * Copy FIJO del módulo de Eventos (español de Costa Rica).
 *
 * Solo lo que el front rotula por sí mismo. El contenido de cada evento —su
 * nombre, ubicación y formato— lo escribe el admin y llega en el payload.
 *
 * Fijado literalmente por `events.constants.spec.ts`.
 */
export const EVENTS_COPY = {
  globalTitle: 'Eventos en Perrón Store',
  subtitle: 'Torneos, lanzamientos y precompras. Todas las horas son de Costa Rica.',

  // Conmutador de vista
  listView: 'Lista',
  calendarView: 'Calendario',
  viewSwitcherLabel: 'Cambiar vista',

  // Filtro
  allGames: 'Todos los juegos',
  gameFilterLabel: 'Filtrar por juego',

  // Estados
  emptyGame: 'No hay eventos programados para este juego por ahora.',
  emptyMonth: 'No hay eventos en',
  loadError: 'No pudimos cargar los eventos. Intenta de nuevo.',

  // SEO
  seoDescription:
    'Calendario de torneos, lanzamientos y precompras de Perrón Store en Costa Rica. Consulta fechas, formatos y precios de los próximos eventos TCG.',

  // ── Próximos eventos en los tres bloques de comunidad ──────────────────
  upcomingTitle: 'Próximos eventos',
  /** Misma cadena que `GAME_SECTION_COPY.allEventsCta`: un solo texto para lo mismo. */
  upcomingCta: 'Ver todos los eventos →',
  /** Verbatim del enlace que ya vivía en el hero de `/comunidad`. */
  communityCalendarLink: 'Ver el calendario de eventos →',
  /** Chip de un evento sin juego — o de uno cuyo juego está despublicado (D12). */
  storeChip: 'Perrón Store',
  communityEmpty:
    'Todavía no hay eventos publicados. Cuando anunciemos el próximo, aparecerá aquí.',

  // ── Detalle de evento (Addenda 1, D26) ─────────────────────────────────
  dialogClose: 'Cerrar',
  /** CTA del enlace externo del evento, que ya no vive en la tarjeta (D21). */
  dialogMoreInfo: 'Más información',
  /** Solo cuando el detalle se abrió desde la vista día (D19). */
  dialogBack: '← Volver',
  /** Se compone «Eventos del 14 de marzo» con `dayLabel` (D25). */
  dayHeadingPrefix: 'Eventos del',
  /** `aria-label` del botón de la tarjeta: «Ver detalles de {nombre}». */
  openDetailsLabel: 'Ver detalles de',
  /** `alt` de la imagen del detalle: «Cartel de {nombre}». */
  imageAltPrefix: 'Cartel de',
  /** Hora de inicio de un evento de varios días, en la tarjeta y en el detalle. */
  eventTimeFrom: '· desde las',
} as const;

/**
 * Cuántos próximos eventos se piden y cuántos enseña cada superficie.
 *
 * Un solo `limit` canónico para las tres (D10): así hay **una** entrada de
 * caché en el backend, **una** clave de `TransferState` y **una** petición por
 * paso de SSR. Cada superficie corta de esa misma respuesta.
 */
export const UPCOMING_EVENTS_LIMITS = {
  /**
   * El doble de `Event::UPCOMING_LIMIT` (6). Cubre el peor caso de
   * deduplicación: aunque los 6 propios de una landing estén todos en el top
   * global, tras descartarlos por `id` quedan 6 de relleno, que es el máximo
   * que la landing puede necesitar.
   */
  request: 12,
  /** La portada ya es larga: tres caben en una fila y leen como anticipo. */
  home: 3,
  /** Es una tira, y es lo único real de esa página. */
  community: 4,
  /** Sin cambio: es `Event::UPCOMING_LIMIT`, ya en producción. */
  gameSection: 6,
} as const;
